export default ({ request }) => ({
    ecomEvgFileUploadApi(data = {}) {
        return request({
            url: '/ecom/evg/files/upload',
            method: 'POST',
            data,
        })
    },
    ecomEvgFileListApi(data = {}) {
        return request({
            url: '/ecom/evg/files/list',
            method: 'POST',
            data,
        })
    },
    ecomImpWmSalesPoUploadApi(data = {}) {
        return request({
            url: '/ecom/impWm/sales/po/upload',
            method: 'POST',
            data,
        })
    },
})
